function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 12,
  cy: 12.6067,
  rx: 12,
  ry: 12.4675,
  fill: "#8BCEFF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.5899 7.55453L14.4476 6.19193C14.1506 6.00372 13.7668 6.22204 13.7668 6.57888V8.93821C13.7668 9.0963 13.8462 9.24235 13.9771 9.32516L15.2828 10.1563L15.8048 10.4875C16.09 10.6697 15.965 11.1199 15.6283 11.1199H14.2109C13.9653 11.1199 13.7654 11.3246 13.7654 11.5761V13.9821C13.7654 15.0376 12.8787 15.8837 11.8289 15.7828C10.9143 15.694 10.2336 14.8704 10.2336 13.9294V11.9962V11.1229V7.94148C10.2336 7.78339 10.1542 7.63734 10.0233 7.55453L7.88097 6.19193C7.58396 6.00372 7.2002 6.22204 7.2002 6.58038V8.93972C7.2002 9.09781 7.27959 9.24386 7.41046 9.32667L8.71614 10.1578L9.23812 10.489C9.52337 10.6712 9.39839 11.1214 9.06167 11.1214H7.64572C7.40016 11.1229 7.2002 11.3262 7.2002 11.5791V13.8767C7.2002 16.5507 9.244 18.8152 11.8554 18.895C14.5682 18.9778 16.8002 16.7419 16.8002 13.9821V11.1229V7.94148C16.8002 7.78489 16.7208 7.63734 16.5899 7.55453Z",
  fill: "white"
});

var SvgUbdiSign = function SvgUbdiSign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUbdiSign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ubdiSign.b0d5dd55.svg";
export { ForwardRef as ReactComponent };